import { Injectable, signal } from '@angular/core';
import { ScreenSize } from '../../../../data-access/models';

@Injectable({
  providedIn: 'root'
})
export class ScreenDetectionService {
  screenType = signal(
    window.innerWidth > ScreenSize.SIZE_991 ? 'desktop' : 'mobile'
  );

  updateScreenType(): void {
    this.screenType.set(
      window.innerWidth > ScreenSize.SIZE_991 ? 'desktop' : 'mobile'
    );
  }

  isMobile(): boolean {
    return this.screenType() === 'mobile';
  }

  isDesktop(): boolean {
    return this.screenType() === 'desktop';
  }
}
